var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-globulo'),_c('message-dispenser'),_c('transition',{attrs:{"name":"fade"}},[_vm._t("default")],2),_c('footer-globulo'),_c('chat-messenger'),_c('organites-scene')],1)}
var staticRenderFns = []

export { render, staticRenderFns }